<template>
    <div>

        <vue-headful :title="(active_folder && active_folder.is_root !== 1 ? active_folder.folder_name+' [Drive Folder]' : 'Drive') + ' :: MeritEHS'"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">

                <li :class="{'breadcrumb-item': true, 'active': ((i + 1) === breadcrumbs.length)}" v-for="(folder, i) in breadcrumbs" v-on:click="viewFolder(folder.id)">
                    <i class="fa fa-files-o" v-if="folder.is_root === 1"></i> {{ folder.folder_name }}
                </li>

                <li class="ml-2" v-if="canEdit">
                    <b-dropdown size="sm" variant="light">
                        <template #button-content>
                            Actions
                        </template>
                        <b-dropdown-item v-on:click="editFolder()" v-if="active_folder"><i class="fa fa-edit"></i> Edit Folder</b-dropdown-item>
                        <b-dropdown-item v-on:click="newFolder()"><i class="fa fa-plus-circle text-success"></i> New Folder</b-dropdown-item>
                        <b-dropdown-item v-on:click="upload_files_show = true"><i class="fa fa-plus-circle text-success"></i> Upload File(s)</b-dropdown-item>
                        <b-dropdown-item v-on:click="delete_folder_show = true" v-if="active_folder && active_folder.is_root !== 1 && canManage">
                            <i class="fa fa-trash text-danger"></i> Delete Folder
                        </b-dropdown-item>
                    </b-dropdown>
                </li>
            </ol>
        </h4>

        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <b-form-input v-model="search" placeholder="Search All Files & Folders" v-on:keyup.enter="searchDrive" />
                </div>

                <div v-if="loading">
                    Loading <i class="fa fa-spinner fa-spin"></i>
                </div>

                <div class="card mb-4" v-if="!loading">
                    <div class="card-header">
                        <strong>Folders ({{ folders.length }}) <span v-if="search && false" class="search-highlight">- {{ search }}</span></strong>

                        <div class="actions pull-right" v-if="canEdit">
                            <button type="button" class="btn btn-sm btn-default" v-on:click="newFolder()">
                                <i class="fa fa-plus-circle text-success"></i> New Folder
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-warning mb-2 small" v-if="active_folder && active_folder.is_public === 1 && canEdit">
                            <strong>Sub-Folders</strong> do not inherit public access. It must be individually turned on for each folder needing to be publicly accessible.
                        </div>

                        <div class="form-group">
                            <b-form-input v-model="search_folders" placeholder="Search Folders" size="sm" />
                        </div>

                        <b-table bordered striped hover :items="folders" :fields="folderFields" small show-empty :filter="search_folders" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                            <template v-slot:cell(id)="data">
                                <b-dropdown size="xs" variant="default">
                                    <template #button-content>
                                        <i class="fa fa-folder-o"></i>
                                    </template>
                                    <b-dropdown-item v-on:click="moveFolder(data.item)"><i class="fa fa-arrows-v"></i> Move Folder</b-dropdown-item>
                                </b-dropdown>
                            </template>
                            <template v-slot:cell(is_public)="data">
                                <span class="badge badge-warning small" title="Folder is Publicly Accessible via the QR Code" v-if="data.item.is_public === 1">
                                    <i class="fa fa-unlock"></i>
                                </span>
                                <span class="badge badge-default small" title="Folder is Private & Requires MeritEHS Authentication" v-else>
                                    <i class="fa fa-lock"></i>
                                </span>
                            </template>
                            <template v-slot:cell(folder_name)="data">
                                <a href="javascript:void(0)" v-if="canView(data.item.access)" v-on:click="viewFolder(data.item.id)">{{ data.item.folder_name }}</a>
                                <span v-else title="You do not have access to view this folder">{{ data.item.folder_name }}</span>
                            </template>
                            <template v-slot:cell(created_at)="data">
                                {{ data.item.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                            </template>
                            <template #empty="scope">
                                <span class="text-center d-block">-- No Folders, <a href="javascript:void(0)" v-on:click="newFolder()"><i class="fa fa-plus-circle text-success"></i> Add Folder</a> to Get Started --</span>
                            </template>
                        </b-table>
                    </div>
                </div>

                <div class="card" v-if="!loading">
                    <div class="card-header">
                        <strong>Files ({{ files.length }})</strong>

                        <div class="action pull-right" v-if="canEdit">
                            <button type="button" class="btn btn-sm btn-default" v-on:click="upload_files_show = true;">
                                <i class="fa fa-plus-circle text-success"></i> Upload File(s)
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-warning mb-2 small" v-if="active_folder && active_folder.is_public === 1">
                            <strong>Note:</strong> This folder has public access enabled. All Files uploaded here will be publicly accessible via the QR Code. To disable public access, Edit the folder via the Folder Actions.
                        </div>

                        <div class="form-group">
                            <b-form-input v-model="search_files" placeholder="Search All Files in Current Folder" size="sm" />
                        </div>

                        <b-table bordered striped hover :items="files" :fields="folderFileFields" small show-empty :filter="search_files" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                            <template v-slot:cell(file_id)="data">
                                <b-dropdown html='<i class="fa fa-ellipsis-h"></i>' variant="default" :no-flip="true" size="xs">
                                    <b-dropdown-item href="javascript:void(0)" v-on:click="viewFile(data.item.file_id)" title="View File" v-if="data.item.download_only === false">
                                        <i class="fa fa-eye"></i> View
                                    </b-dropdown-item>
                                    <b-dropdown-item href="javascript:void(0)" v-on:click="downloadFile(data.item.file_id)" title="Download File">
                                        <i class="fa fa-download"></i> Download
                                    </b-dropdown-item>
                                    <b-dropdown-item href="javascript:void(0)" v-on:click="showFileDelete(data.item.file_id)" title="Delete File" v-if="canManage || (canEdit && data.item.user_id == $store.state.user.user_id)">
                                        <i class="fa fa-trash text-danger"></i> Delete
                                    </b-dropdown-item>
                                </b-dropdown>
                            </template>
                            <template v-slot:cell(file_name)="data">
                                <router-link :to="`/files/view/${data.item.file_id}`" v-if="false">{{ data.item.file_name }}</router-link>
                                <a href="javascript:void(0)" v-on:click="showFileDetails(data.index)">{{ data.item.file_name }}</a>
                            </template>
                            <template v-slot:cell(created_at)="data">
                                {{ data.item.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                            </template>
                            <template v-slot:cell(folder_id)="data">
                                <a href="javascript:void(0)" v-on:click="viewFolder(data.item.folder_id)" v-if="data.item.folder_id != active_folder.id">{{ data.item.folder_name }}</a>
                                <span v-else>{{ data.item.folder_name }}</span>
                            </template>

                            <template #empty="scope">
                                <span class="text-center d-block">-- No Files<span v-if="$root.hasPermission('drive.manage')">, Use the Uploader Below to Get Started</span> --</span>
                            </template>
                        </b-table>

                        <div id="add-file-button" class="text-center" style="border: 1px dashed #cccccc; padding: 8px 5px;" v-on:click="upload_files_show = true;" v-if="false">
                            <i class="fa fa-plus-circle text-success"></i> Upload File(s)
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card mb-4">
                    <div class="card-header">
                        <i class="fa fa-folder-open"></i>
                        <span v-if="active_folder"><span class="text-muted">Folder:</span> {{ active_folder.folder_name }}</span>
                        <span v-else>Drive</span>
                    </div>
                    <div class="card-body">
                        <div class="row mb-2">
                            <label class="col-md-5 text-muted text-md-right">Created:</label>
                            <div class="col-md-7" v-if="active_folder">{{ active_folder.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a")  }}</div>
                        </div>
                        <div class="row mb-2">
                            <label class="col-md-5 text-muted text-md-right">Last Updated:</label>
                            <div class="col-md-7" v-if="active_folder">{{ active_folder.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a")  }}</div>
                        </div>
                        <div class="row mb-2">
                            <label class="col-md-5 text-muted text-md-right">Total Files:</label>
                            <div class="col-md-7">{{ files.length }}</div>
                        </div>
                        <div class="row mb-2">
                            <label class="col-md-5 text-muted text-md-right">Total Folders:</label>
                            <div class="col-md-7">{{ folders.length }}</div>
                        </div>
                        <div class="row mb-2">
                            <label class="col-md-5 text-muted text-md-right">Access:</label>
                            <div class="col-md-7">
                                <span class="badge badge-warning" v-if="active_folder && active_folder.is_public"><i class="fa fa-unlock"></i> Public</span>
                                <span class="badge badge-default" v-else>Private</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-4" v-if="active_folder && active_folder.is_root !== 1 && canManage">
                    <div class="card-header">
                        <strong>Access Permissions ({{ permissions.length }})</strong>

                        <a href="javascript:void(0)" v-on:click="show_access_perm_help = !show_access_perm_help"><i class="fa fa-question-circle"></i></a>

                        <div class="actions pull-right">
                            <button type="button" class="btn btn-sm btn-default" v-on:click="newPermission()">
                                <i class="fa fa-plus-circle text-success"></i> Add Access
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <ul class="list-unstyled" v-if="permissions.length > 0">
                            <li v-for="perm in permissions">
                                <button type="button" class="btn btn-xs btn-default" v-on:click="deletePermission(perm.id)">
                                    <i class="fa fa-trash text-danger"></i>
                                </button>
                                {{ perm.permission_type }} - {{ perm.name }}: <label class="badge badge-default small">{{ perm.access_type }}</label>
                            </li>
                        </ul>
                        <span v-else class="small text-muted">
                            -- No Access Permissions Applied. Any logged in User with Drive - View can access this folder & file contents --
                        </span>
                    </div>
                </div>

                <div class="card mb-4" v-if="active_folder && active_folder.is_root !== 1">
                    <div class="card-header">
                        <i class="fa fa-building""></i> Assigned Jobsites ({{ jobsites.length }})
                        <div class="pull-right" v-if="canManage && $root.hasPermission('jobsites.manage')">
                            <button type="button" class="btn btn-sm btn-default" v-on:click="add_jobsite = !add_jobsite">
                                <i :class="'fa fa-'+(add_jobsite ? 'remove' : 'plus-circle')"></i> <span v-if="add_jobsite">Cancel</span> Add
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="mb-3" v-if="add_jobsite">
                            <v-select
                                v-model="new_jobsite"
                                label="jobsite_name_nbr"
                                :filterable="false"
                                @search="searchJobsites"
                                :options="jobsiteOptions"
                                :placeholder="`Search Jobsites`"
                                :class="{'is-invalid': errors.jobsite_id}">
                                <template slot="no-options">
                                    Search Jobsites
                                </template>
                            </v-select>
                        </div>

                        <span v-if="loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                        </span>
                        <ul class="list-unstyled" v-else>
                            <template v-if="jobsites.length > 0">
                               <li v-for="jobsite in jobsites" class="mb-2">
                                   <button type="button" class="btn btn-xs btn-default" v-if="canManage && $root.hasPermission('jobsites.manage')" v-on:click="removeJobsite(jobsite)">
                                        <i class="fa fa-unlink text-danger"></i>
                                    </button>

                                   <router-link :to="`/jobsites/view/${jobsite.JobsiteId}`">{{ jobsite.JobsiteNumber }} - {{ jobsite.JobsiteName }}</router-link>
                               </li>
                           </template>
                           <li v-else>
                               -- No Assigned Jobsites --
                           </li>
                        </ul>
                    </div>
                </div>

                <div class="card mb-4" v-if="active_folder && active_folder.is_public === 1">
                    <div class="card-header">
                        <i class="fa fa-unlock"></i> Public Access
                    </div>
                    <div class="card-body">
                        <qr-code :qr_code_url="`${$root.appUrl}/drive/folder/${active_folder.folder_key}`" :qr_code_name="'Drive-Folder-'+active_folder.folder_name" :show_url="true" />
                    </div>
                </div>

                <div class="card" v-if="active_file">
                    <div class="card-header">
                        <strong>File Details</strong>

                        <button type="button" class="btn btn-sm btn-default pull-right" v-on:click="active_file = null;"><i class="fa fa-times"></i></button>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label class="text-muted d-block mb-0">Name:</label>

                            <router-link :to="`/files/view/${active_file.file_id}`" title="View File" v-if="active_file.download_only === false">{{ active_file.file_name }}</router-link>
                            <a :href="`/files/download/${active_file.file_id}`" title="Download File" v-else>{{ active_file.file_name }}</a>
                        </div>

                        <div class="form-group">
                            <label class="text-muted d-block mb-0">Created:</label>
                            {{ active_file.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                        </div>

                        <div class="form-group">
                            <label class="text-muted d-block mb-0">Type:</label>
                            {{ active_file.file_extension }}
                        </div>

                        <div class="form-group">
                            <label class="text-muted d-block mb-0">Uploaded By:</label>
                            {{ active_file.FirstName }} {{ active_file.LastName }}
                        </div>

                        <div class="form-group">
                            <label class="text-muted d-block">Folder:</label>
                            <a href="javascript:void(0)" v-on:click="viewFolder(active_file.folder_id)" title="View Folder">{{ active_file.folder_name }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            v-model="add_edit_folder_show"
            :title="(add_edit_folder.parent_folder_name ? add_edit_folder.parent_folder_name+' / ' : '') + (add_edit_folder.id ? 'Edit Folder' : 'New Folder in ' + (active_folder ? active_folder.folder_name : '') )"
            :ok-title="(add_edit_folder.id ? 'Update ' : 'Create' )"
            :ok-disabled="saving_folder"
            ok-variant="success"
            no-fade
            @hide="handleHide"
            @hidden="handleHidden"
            @ok="handleOk"
            ref="addEditFolderModal"
            :no-close-on-backdrop="true"
            scrollable
            size="lg">

            <div style="min-height: 150px;">
                <div class="row mb-3">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.folder_name, 'text-muted': !errors.folder_name}">
                        Folder Name:
                    </label>
                    <div class="col-md-8 col-sm-8">
                        <b-form-input v-model="add_edit_folder.folder_name" placeholder="Enter Folder Name" :class="{'is-invalid': errors.folder_name}" />

                        <div v-if="errors.folder_name" class="text-danger mt-1">
                            <span v-for="error in errors.folder_name">{{ error }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.is_public, 'text-muted': !errors.is_public}">
                        Is Public:
                    </label>
                    <div class="col-md-8 col-sm-8">
                        <b-form-checkbox v-model="add_edit_folder.is_public" :value="1" :unchecked-value="0" plain>
                            Public Folders will generate a QR Code to enable public access.
                        </b-form-checkbox>

                        <div v-if="errors.is_public" class="text-danger mt-1">
                            <span v-for="error in errors.is_public">{{ error }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mb-2" v-if="!add_edit_folder.id && permissions.length > 0">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.clone_access_permissions, 'text-muted': !errors.clone_access_permissions}">
                        Clone Access Permissions:
                    </label>
                    <div class="col-md-8 col-sm-8">
                        <b-form-checkbox v-model="add_edit_folder.clone_access_permissions" :value="1" :unchecked-value="0" plain>
                            All Access Permissions for the Current Folder with be cloned to the new folder
                        </b-form-checkbox>

                        <ul class="list-unstyled mt-2">
                            <li v-for="perm in permissions">
                                {{ perm.permission_type }} - {{ perm.name }}: <label class="badge badge-default small">{{ perm.access_type }}</label>
                            </li>
                        </ul>

                        <div v-if="errors.clone_access_permissions" class="text-danger mt-1">
                            <span v-for="error in errors.clone_access_permissions">{{ error }}</span>
                        </div>
                    </div>
                </div>
            </div>

        </b-modal>

        <b-modal
            v-model="delete_folder_show"
            :title="'Delete Folder' + (active_folder ? active_folder.text : '')"
            ok-title="Delete Folder"
            :ok-disabled="action_in_progress"
            ok-variant="danger"
            no-fade
            @hidden="handleHidden"
            @ok="deleteFolder"
            ref="deleteFolderModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div style="min-height: 100px;">
                <div class="alert alert-danger">
                    <strong>Warning:</strong> You are about to delete this folder and ALL its sub-contents. This cannot be reversed.
                </div>

                <div class="row">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.delete_phrase}">
                        Type "delete" to Confirm:
                    </label>
                    <div class="col-md-8 col-sm-8">
                        <b-form-input v-model="delete_phrase" placeholder="Type the word 'delete' to confirm" :class="{'is-invalid': errors.delete_phrase}" />

                        <div v-if="errors.delete_phrase" class="text-danger mt-1">
                            <span v-for="error in errors.delete_phrase">{{ error }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
            v-model="delete_file_show"
            :title="'Delete File: ' + (active_file ? active_file.file_name : '')"
            ok-title="Delete File"
            :ok-disabled="action_in_progress"
            ok-variant="danger"
            no-fade
            @hidden="handleHidden"
            @ok="deleteFile"
            ref="deleteFileModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div style="min-height: 100px;">
                <div class="alert alert-danger">
                    <p>
                        <strong>Warning:</strong> You are about to delete the following file. This cannot be reversed.<br/><br/>
                        <strong v-if="delete_file">{{ delete_file.file_name }}</strong>
                    </p>
                    <p>
                        To confirm, please type in all lowercase: 'delete file'
                        <div class="input-group-sm">
                            <input type="text" v-model="confirm_delete" placeholder="Type 'delete file' to confirm delete" class="form-control" />
                        </div>
                    </p>
                </div>
            </div>
        </b-modal>

        <b-modal
            v-model="upload_files_show"
            :title="'Upload Files to ' + (active_folder ? active_folder.folder_name : '')"
            ok-title="Close"
            :ok-disabled="action_in_progress"
            ok-variant="secondary"
            :ok-only="true"
            no-fade
            @ok="(() => { this.upload_files_show = false; })"
            ref="newFilesModal"
            :no-close-on-backdrop="true"
            size="lg"
            scrollable>

            <div style="min-height: 100px;">
                <vue2-dropzone ref="driveFiles" id="dropzone" :options="dropzoneOptions" :useCustomSlot="true" @vdropzone-success="fileUploaded" @vdropzone-queue-complete="uploadComplete">
                    <div class="dropzone-custom-content">
                        <h5 class="dropzone-custom-title">
                            <i class="fa fa-plus-circle text-success"></i> Drag and Drop Files to Upload
                        </h5>
                        <div class="subtitle">...or click to select files</div>
                    </div>
                </vue2-dropzone>
            </div>

        </b-modal>

        <b-modal
            v-model="add_edit_permissions"
            :title="'Edit Permissions for ' + (active_folder ? active_folder.folder_name : '')"
            ok-title="Save"
            :ok-disabled="action_in_progress"
            ok-variant="success"
            no-fade
            @ok="savePermission"
            ref="addEditPermissions"
            :no-close-on-backdrop="true"
            size="lg"
            scrollable>

            <div style="min-height: 250px;">
                <div class="row mb-2">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.access_type, 'text-muted': !errors.access_type}">
                        Access Level: <i class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-8 col-sm-8">
                        <b-form-select v-model="add_edit_permission.access_type" :options="permissionAccessTypes" :class="{'is-invalid': errors.access_type}" />

                        <div v-if="errors.access_type" class="text-danger mt-1">
                            <span v-for="error in errors.access_type">{{ error }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.permission_type, 'text-muted': !errors.permission_type}">
                        Access Type: <i class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-8 col-sm-8">
                        <b-form-radio-group
                            v-model="add_edit_permission.permission_type"
                            :options="[{value: 'Role', text: 'Role'}, {value: 'User', text: 'User'}]"
                            plain
                            name="permission_type" />

                        <div v-if="errors.permission_type" class="text-danger mt-1">
                            <span v-for="error in errors.permission_type">{{ error }}</span>
                        </div>
                    </div>
                </div>

                <div class="row mb-2" v-if="add_edit_permission.permission_type">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.permission_id, 'text-muted': !errors.permission_id}">
                        {{ add_edit_permission.permission_type }}: <i class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-8 col-sm-8">
                        <role-select
                            v-if="add_edit_permission.permission_type === 'Role'"
                            :selectedValues="{}"
                            v-on:vuselected="((data) => { this.add_edit_permission.role_id = data ? data.id : null;  })" />

                        <user-select
                            v-if="add_edit_permission.permission_type === 'User'"
                            :selectedValues="{}"
                            v-on:vuselected="((data) => { this.add_edit_permission.user_id = data ? data.UserId : null;  })" />


                        <div v-if="errors.permission_id" class="text-danger mt-1">
                            <span v-for="error in errors.permission_id">{{ error }}</span>
                        </div>
                    </div>
                </div>
            </div>

        </b-modal>

        <b-modal
            v-model="delete_permission"
            :title="'Remove Permission to Folder' + (active_folder ? active_folder.text : '')"
            ok-title="Remove Permission"
            :ok-disabled="action_in_progress"
            ok-variant="danger"
            no-fade
            @hidden="handleHidden"
            @ok="postDeletePermission"
            ref="deletePermissionModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div style="min-height: 100px;">
                <div class="alert alert-danger">
                    <strong>Warning:</strong> You are about to remove this Permission from the Active Folder. {{ add_edit_permission.permission_type }}: {{ add_edit_permission.name }} will no longer have the specified access.
                </div>
            </div>
        </b-modal>

        <b-modal
            v-model="show_move_folder"
            :title="'Move Folder: ' + move_folder.folder_name"
            ok-title="Move Folder"
            :ok-disabled="action_in_progress"
            ok-variant="info"
            no-fade
            @hidden="handleHidden"
            @ok="postMoveFolder"
            ref="moveFolderModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div style="min-height: 100px;">
                <b-form-radio-group plain stacked v-model="move_folder.new_parent_folder_id">
                    <b-form-radio :value="folder.id" v-for="folder in moveFolderOptions" :key="folder.id">
                        {{ folder.folder_name }}
                    </b-form-radio>
                </b-form-radio-group>
            </div>
        </b-modal>

        <b-modal
            v-model="show_access_perm_help"
            :title="'MeritEHS Drive - Access Permissions'"
            :ok-only="true"
            ok-title="Close"
            ok-variant="default"
            size="lg"
            no-fade
            :no-close-on-backdrop="true">

            <div>
                <strong>Access Permissions</strong> provide a way to customize who can view, edit, and manage files and folders in your MeritEHS Drive.<br/><br/>

                <strong>Access Type:</strong>
                <ul>
                    <li>There are two types of Access Types: <strong>Users</strong> and <strong>Roles</strong></li>
                    <li><strong>User</strong> - Directly assign user(s) to a folder.</li>
                    <li><strong>Role</strong> - Assign a Role from your Settings to a folder. All users with this Role will be granted access.</li>
                </ul>

                <strong>Access Level:</strong>
                <ul>
                    <li>There are three levels of Access <strong>View</strong>, <strong>Edit</strong>, and <strong>Manage</strong></li>
                    <li>
                        <strong>View</strong> - The specificed access type can VIEW the folder and it's files.
                        <ul>
                           <li>NOTE: Sub-folders must have their own access rules set. They do not inherit from the parent folder.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>Edit</strong> - The specified access type can View the Folder, Upload Files, Rename the Folder, Create New Sub-Folders, and Delete files they uploaded.
                        <ul>
                            <li>NOTE: Edit includes the View Level, so you do not need to add 2 permissions to provide View & Edit Level Access.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>Manage</strong> - The specified access type can perform all actions of View & Edit, plus Delete the current folder and files therein.
                        <ul>
                            <li>NOTE: Manage includes the View & Edit Levels, so you do not need to add 3 permissions to provide the capabilities of the lower levels.</li>
                        </ul>
                    </li>
                </ul>

                <strong>Conditions:</strong>
                <ul>
                    <li>All Users must still have the <i>Drive - View</i> permission on at least 1 of their assigned roles.</li>
                    <li>
                        The Root MeritEHS Drive folder cannot have permissions assign.
                        <ul>
                            <li>This is the starting point for the drive, so access cannot be restricted.</li>
                            <li>All files uploaded in the root directly <strong>will be visible by any user with the "Drive - View" user permission</strong></li>
                        </ul>
                    </li>
                    <li>
                        Folder permissions operate as an "Allow All" access, so if there are NO permissions, general view access is always granted.
                        <ul>
                            <li>If no permissions are present, only users with "Drive - Manage" user permission will be able to Upload Files, Create Sub-Folders, Rename Folders, and Delete Files/Folders</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                loading_recent: false,
                saving_folder: false,
                action_in_progress: false,
                active_folder: null,
                delete_folder: null,
                active_file: null,
                delete_file: null,
                delete_phrase: null,
                add_edit_folder_show: false,
                delete_folder_show: false,
                delete_file_show: false,
                upload_files_show: false,
                add_edit_permissions: false,
                delete_permission: false,
                show_access_perm_help: false,
                show_move_folder: false,
                move_folder: {},
                search: null,
                search_files: null,
                search_folders: null,
                root_folder_id: null,
                confirm_delete: null,
                starting_folder_id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                add_edit_folder: {},
                add_edit_permission: {},
                breadcrumbs: [],
                folders: [],
                files: [],
                permissions: [],
                recent: [],
                errors: {},

                add_jobsite: false,
                new_jobsite: null,
                jobsites: [],
                jobsiteOptions: [],

                permissionAccessTypes: [
                    {value: 'View', text: 'View'},
                    {value: 'Edit', text: 'Edit'},
                    {value: 'Manage', text: 'Manage'},
                ],

                folderFields: [
                    {
                        key: 'id',
                        label: 'Actions',
                    },
                    {
                        key: 'is_public',
                        label: 'Public',
                        sortable: true,
                    },
                    {
                        key: 'folder_name',
                        label: 'Name',
                        sortable: true,
                    },
                    {
                        key: 'created_at',
                        label: 'Created',
                        sortable: true,
                    },
                ],

                folderFileFields: [
                    {
                        key: 'file_id',
                        label: 'Actions',
                    },
                    {
                        key: 'file_name',
                        label: 'Name',
                        sortable: true,
                    },
                    {
                        key: 'file_extension',
                        label: 'Type',
                    },
                    {
                        key: 'created_at',
                        label: 'Created',
                        sortable: true,
                    },
                    {
                        key: 'folder_id',
                        label: 'Folder',
                    }
                ],

                sortBy: 'created_at',
                sortDesc: true,
            }
        },

        computed: {
            dropzoneOptions()
            {
                //Setup
                var url = '';

                //Set it
                if(this.active_folder)
                {
                    url = '/api/v1/drive/files/upload?folder_id='+this.active_folder.id+'&asset_type=FileFolder&asset_id='+this.active_folder.id;
                }

                //Send it
                return {
                    url: url,
                    thumbnailWidth: 100,
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem('app_token')
                    }
                }
            },

            canManage(){
                //Check Folder Permissions
                if(this.permissions.length > 0)
                {
                    //Loop and Process
                    for (var i = this.permissions.length - 1; i >= 0; i--)
                    {
                        //Check for Direct User
                        if(this.permissions[i].access_type !== 'Manage')
                        {
                            continue;
                        }

                        //Check User
                        if(this.permissions[i].permission_type === 'User' && this.permissions[i].permission_id == this.$store.state.user.user_id)
                        {
                            return true;
                        }

                        //Check Role
                        if(this.permissions[i].permission_type === 'Role' && this.userRoles.indexOf(this.permissions[i].permission_id) !== -1)
                        {
                            return true;
                        }
                    }
                }

                //Default to permissions
                return this.$root.hasPermission('drive.manage');
            },

            canEdit(){
                //Check Permission
                if(this.permissions.length > 0)
                {
                    //Loop and Process
                    for (var i = this.permissions.length - 1; i >= 0; i--)
                    {
                        //Check for Direct User
                        if(this.permissions[i].access_type !== 'Edit' && this.permissions[i].access_type !== 'Manage')
                        {
                            continue;
                        }

                        //Check User
                        if(this.permissions[i].permission_type === 'User' && this.permissions[i].permission_id == this.$store.state.user.user_id)
                        {
                            return true;
                        }

                        //Check Role
                        if(this.permissions[i].permission_type === 'Role' && this.userRoles.indexOf(this.permissions[i].permission_id) !== -1)
                        {
                            return true;
                        }
                    }
                }

                //Default to permissions
                return this.$root.hasPermission('drive.manage');
            },

            userRoles(){
                //Setup
                var ids = [];

                //Loop
                for (var i = this.$store.state.user.roles.length - 1; i >= 0; i--)
                {
                    //Push
                    ids.push(this.$store.state.user.roles[i].id);
                }

                //Send it
                return ids;
            },

            moveFolderOptions(){
                //Setup
                var options = [];

                //Check for an Active Folder
                if(this.active_folder && this.active_folder.is_root != 1)
                {
                    //Push the Parent Folder
                    var parent = this.breadcrumbs[this.breadcrumbs.length - 2];

                    //Push the folder
                    options.push({
                        id: parent.id,
                        folder_name: parent.folder_name + ' (Move Up 1 Level to Parent Folder)',
                    });
                }

                //Loop and Build
                for (var i = 0; i < this.folders.length; i++)
                {
                    //Check against move folder
                    if(this.move_folder.id != this.folders[i].id)
                    {
                        options.push(this.folders[i]);
                    }
                }

                //Send it
                return options;
            },
        },

        watch: {
            search(newVal, oldVal)
            {
                //Check Empty or Null
                if( (newVal === '' || newVal === null) && (oldVal !== '' && oldVal !== null) )
                {
                    //Reset
                    this.searchDrive();
                }
            },

            new_jobsite(new_val, old_val)
            {
                //Send it
                if(new_val === null || !new_val.JobsiteId)
                {
                    return;
                }

                //SEnd it
                this.addJobsiteToFolder(this.new_jobsite);
            }
        },

        methods: {
            //Get the Account
            getActiveFolder(parent_folder_id = null)
            {
                //Loading
                this.loading = true;
                this.active_file = null;

                //Get the data
                this.$http
                    .get('/drive/folders' + (parent_folder_id ? '/' + parent_folder_id : ''), {search: this.search} )
                    .then(response => {
                        //Set the Values
                        this.breadcrumbs = response.data.breadcrumbs;
                        this.active_folder = response.data.active_folder;
                        this.folders = response.data.folders;
                        this.files = response.data.files;
                        this.permissions = response.data.permissions;
                        this.jobsites = response.data.jobsites;

                        //Check for root
                        if(this.active_folder.is_root == 1)
                        {
                            //this.getRecentlyViewed();
                        }
                        else
                        {
                            //this.$router.replace('/drive/'+this.active_folder.id);
                        }
                    })
                    .catch(response => {
                        //Do what?
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            //Get the Account
            getRecentlyViewed()
            {
                //Loading
                this.loading_recent = true;

                //Get the data
                this.$http
                    .get('/recently-viewed', {record_type: 'File_'})
                    .then(response => {
                        //Set the Values
                        this.recent = response.data;
                    })
                    .catch(response => {
                        //Do what?
                    })
                    .then(() => {
                        //Reset
                        this.loading_recent = false;
                    });
            },

            searchDrive()
            {
                //Do anything special?

                this.getActiveFolder();
            },

            saveFolder()
            {
                //Loading
                this.saving_folder = true;

                //Get the data
                this.$http
                    .post('/drive/folders', this.add_edit_folder )
                    .then(response => {
                        //Set the active folder
                        if(this.add_edit_folder.id === this.active_folder.id)
                        {
                            //Just Update the Name
                            this.active_folder.folder_name = this.add_edit_folder.folder_name;

                            //Update the Public Settings
                            this.active_folder.is_public = this.add_edit_folder.is_public;

                            //Set the Key
                            this.active_folder.folder_key = response.data.folder_key;

                            //Update the LAST breadcrubm
                            this.breadcrumbs[(this.breadcrumbs.length - 1)].folder_name = this.add_edit_folder.folder_name;
                        }
                        else
                        {
                            //Push onto the stack
                            this.folders.push(response.data);
                        }

                        //Hide the MOdal
                        this.add_edit_folder_show = false;
                    })
                    .catch(error => {
                        //Check for error
                        if (error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving_folder = false;
                    });
            },

            canView(folder_access_permissions = [])
            {
                //Check for empty
                if(folder_access_permissions.length === 0 || this.canManage)
                {
                    //Default to true if there are no rules
                    return true;
                }

                //Loop and Process
                for (var i = folder_access_permissions.length - 1; i >= 0; i--)
                {
                    //Check for Direct User
                    // if(folder_access_permissions[i].access_type !== 'View')
                    // {
                    //     continue;
                    // }

                    //Check User
                    if(folder_access_permissions[i].permission_type === 'User' && folder_access_permissions[i].permission_id == this.$store.state.user.user_id)
                    {
                        return true;
                    }

                    //Check Role
                    if(folder_access_permissions[i].permission_type === 'Role' && this.userRoles.indexOf(folder_access_permissions[i].permission_id) !== -1)
                    {
                        return true;
                    }
                }

                //Defualt is false at this point
                return false;
            },

            viewFolder(folder_id){
                //Check if current folder is already the location
                if(folder_id === this.active_folder.id)
                {
                    return;
                }

                //setup
                var is_root = false;

                //Loop and Check
                for (var i = 0; i < this.breadcrumbs.length; i++)
                {
                    //Check it
                    if(this.breadcrumbs[i].id === folder_id && this.breadcrumbs[i].is_root === 1)
                    {
                        is_root = true;
                    }
                }

                //Get it
                //this.getActiveFolder(folder_id);
                this.$router.push('/drive' + (!is_root ? '/'+folder_id : '') );
            },

            newFolder(){
                //Set the active folder
                this.add_edit_folder = {
                    "parent_folder_id": this.active_folder.id,
                    "folder_name": "New Folder",
                    "clone_access_permissions": 1,
                };

                //Show the MOdel
                this.add_edit_folder_show = true;
            },

            editFolder(){
                //Setup
                //Set the active folder
                this.add_edit_folder = {
                    "id": this.active_folder.id,
                    "parent_folder_id": this.active_folder.parent_folder_id,
                    "folder_name": this.active_folder.folder_name,
                    "is_public": this.active_folder.is_public,
                };

                //Show
                this.add_edit_folder_show = true;
            },

            moveFolder(folder){
                //What do we need to do now?
                this.move_folder = folder;

                //Show it
                this.show_move_folder = true;
            },

            newPermission(){
                //Set the active folder
                this.add_edit_permission = {
                    "access_type": "View",
                    "permission_type": null,
                    "permission_id": null,
                    "user_id": null,
                    "role_id": null,
                };

                //Show the MOdel
                this.add_edit_permissions = true;
            },

            deletePermission(id){
                //Set it
                for (var i = this.permissions.length - 1; i >= 0; i--)
                {
                    if(this.permissions[i].id === id)
                    {
                        this.add_edit_permission = this.permissions[i];
                    }
                }

                //Show the modal
                this.delete_permission = true;
            },

            savePermission(bvEvt){
                //Prevent Default
                bvEvt.preventDefault();

                //Loading
                this.action_in_progress = true;

                //Setup the Payload
                var payload = {
                    asset_type: 'FileFolder',
                    asset_id: this.active_folder.id,
                    permission_type: this.add_edit_permission.permission_type,
                    access_type: this.add_edit_permission.access_type,
                };

                //Setup
                switch(payload.permission_type)
                {
                    case 'Role':
                        //Setup
                        payload.permission_id = this.add_edit_permission.role_id;
                        break;

                    case 'User':
                        //Set
                        payload.permission_id = this.add_edit_permission.user_id;
                        break;
                }

                //Get the data
                this.$http
                    .post('/drive/permissions', payload)
                    .then(response => {
                        //Now what?
                        this.$toastr.success('Permission Updated');

                        //Set the name for rendering
                        var perm = response.data;
                        var updated = false;

                        //Check the type
                        switch(perm.permission_type)
                        {
                            case 'Role':
                                //Set it
                                perm.name = perm.permission.name;
                                break;
                            case 'User':
                                //Set it
                                perm.name = perm.permission.FirstName+' '+perm.permission.LastName;
                                break;
                        }

                        //Check if we need to add or update
                        for (var i = this.permissions.length - 1; i >= 0; i--)
                        {
                            //Check the ID
                            if(this.permissions[i].id == perm.id)
                            {
                                //Splice it in
                                this.permissions.splice(i, 1, perm);

                                //Set the helper
                                updated = true;
                            }
                        }

                        if(!updated)
                        {
                            //Append
                            this.permissions.push(perm);
                        }

                        //Reset
                        this.add_edit_permission = {};

                        //Hide
                        this.add_edit_permissions = false;
                    })
                    .catch(error => {
                        //Check Error
                        if(!error.response || !error.response.status)
                        {
                            //Logging
                            console.log(error);

                            //Alert the User
                            this.$toastr.error(error);

                            //Stop Here
                            return;
                        }

                        switch(error.response.status)
                        {
                            case 422:
                                //Display validation errors
                                this.errors = error.response.data;
                                break;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.action_in_progress = false;
                    });
            },

            postDeletePermission(bvEvt){
                //Stops the modal from closing
                bvEvt.preventDefault();

                //Loading
                this.action_in_progress = true;

                //Setup the Payload
                var payload = {
                    asset_type: this.add_edit_permission.asset_type,
                    asset_id: this.add_edit_permission.asset_id,
                    permission_type: this.add_edit_permission.permission_type,
                    permission_id: this.add_edit_permission.permission_id,
                    id: this.add_edit_permission.id,
                };

                //Get the data
                this.$http
                    .delete('/drive/permissions', payload)
                    .then(response => {
                        //Now what?
                        this.$toastr.success('Permission Removed');

                        //Parse Out
                        for (var i = this.permissions.length - 1; i >= 0; i--)
                        {
                            if(this.permissions[i].id === this.add_edit_permission.id)
                            {
                                this.permissions.splice(i, 1);
                            }
                        }

                        //Reset the Delete Phrase
                        this.add_edit_permission = {};
                        this.delete_permission = false;
                    })
                    .catch(error => {
                        //Check Error
                        if(!error.response || !error.response.status)
                        {
                            //Logging
                            console.log(error);

                            //Alert the User
                            this.$toastr.error(error);

                            //Stop Here
                            return;
                        }

                        switch(error.response.status)
                        {
                            case 422:
                                //Display validation errors
                                this.errors = error.response.data;
                                break;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.action_in_progress = false;
                    });
            },

            postMoveFolder(bvEvt){
                //Stops the modal from closing
                bvEvt.preventDefault();

                //Loading
                this.action_in_progress = true;

                //Setup the Payload
                var payload = {
                    new_parent_folder_id: this.move_folder.new_parent_folder_id,
                };

                //Get the data
                this.$http
                    .post('/drive/folders/move/'+this.move_folder.id, payload)
                    .then(response => {
                        //Now what?
                        this.$toastr.success('Folder Moved');

                        //Reset the Delete Phrase
                        this.move_folder = {};
                        this.show_move_folder = false;

                        //Reload the Data
                        this.getActiveFolder( (this.active_folder ? this.active_folder.id : null) );
                    })
                    .catch(error => {
                        //Check Error
                        if(!error.response || !error.response.status)
                        {
                            //Logging
                            console.log(error);

                            //Alert the User
                            this.$toastr.error(error);

                            //Stop Here
                            return;
                        }

                        switch(error.response.status)
                        {
                            case 422:
                                //Display validation errors
                                this.errors = error.response.data;
                                break;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.action_in_progress = false;
                    });
            },

            fileUploaded(file, response){
                //Push onto the stack
                this.files.push(response);

                //Alert the user? This would fire SEVERAL alerts, we don't want that.

                //Remove the file?
                this.$refs.driveFiles.removeFile(file);
            },

            uploadComplete(){
                //Alert the user
                this.$toastr.success('File(s) Uploaded');

                //Hide
                this.upload_files_show = false;
            },

            handleHide(bvEvt) {
                //Do anything?
            },

            handleHidden(bvEvt) {
                //Reset the values
                this.add_edit_folder = {};
                this.add_edit_permission = {};
                this.errors = {};
            },

            handleOk(bvEvt) {
               //Stops the modal from closing
               bvEvt.preventDefault();

               //Send it
                this.saveFolder();
            },

            deleteFolder(bvEvt){
                //Stops the modal from closing
                bvEvt.preventDefault();

                //Loading
                this.action_in_progress = true;

                //Get the data
                this.$http
                    .delete('/drive/folders/'+this.active_folder.id, {delete_phrase: this.delete_phrase})
                    .then(response => {
                        //Now what?
                        this.$toastr.success('Folder Deleted');

                        //How to remove / update the nodes?
                        this.viewFolder(response.data.parent_folder_id)

                        //Reset the Delete Phrase
                        this.delete_phrase = null;
                        this.delete_folder_show = false;
                    })
                    .catch(error => {
                        //Check Error
                        if(!error.response || !error.response.status)
                        {
                            //Logging
                            console.log(error);

                            //Alert the User
                            this.$toastr.error(error);

                            //Stop Here
                            return;
                        }

                        switch(error.response.status)
                        {
                            case 422:
                                //Display validation errors
                                this.errors = error.response.data;
                                break;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.action_in_progress = false;
                    });
            },

            viewFile(file_id){
                //Send it
                //this.$router.push('/files/view/'+file_id);
                window.location = '/files/view/'+file_id;
            },

            downloadFile(file_id){
                //Send it
                window.location = '/files/download/'+file_id;
            },

            deleteFile(bvModalEvent){
                //Prevent it
                bvModalEvent.preventDefault();

                //check Delete
                if(this.confirm_delete !== 'delete file')
                {
                    //Cofirm
                    this.$toastr.warning('You must type the key phrase to confirm deletion');

                    //Stop Here
                    return;
                }

                //Loading
                this.action_in_progress = true;

                //Get the data
                this.$http
                    .post('/files/delete/'+this.delete_file.file_id)
                    .then(response => {
                        //Now what?
                        this.$toastr.success('File Deleted');

                        //How to remove / update the nodes?
                        for (var i = this.files.length - 1; i >= 0; i--)
                        {
                            //Check ID
                            if(this.files[i].file_id == this.delete_file.file_id)
                            {
                                //Remove
                                this.files.splice(i, 1);
                            }
                        }

                        //Reset
                        this.delete_file = null;
                        this.confirm_delete = null;

                        //Close the modal
                        this.$refs.deleteFileModal.hide();
                    })
                    .catch(error => {
                        //Check Error
                        if(!error.response || !error.response.status)
                        {
                            //Logging
                            console.log(error);

                            //Alert the User
                            this.$toastr.error(error);

                            //Stop Here
                            return;
                        }

                        switch(error.response.status)
                        {
                            case 422:
                                //Display validation errors
                                this.errors = error.response.data;
                                break;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.action_in_progress = false;
                    });
            },

            showFileDetails(i){
                //Set the Active File
                this.active_file = this.files[i];
            },

            showFileDelete(file_id){
                //Set the file - EHS-1451, Index is wrong and deleting the wrong files
                //this.delete_file = this.files[i];
                for (var i = 0; i < this.files.length; i++)
                {
                    //Check the ID
                    if(this.files[i].file_id == file_id)
                    {
                        //Delete the file
                        this.delete_file = this.files[i];
                    }
                }

                //Show it
                this.delete_file_show = true;
            },

            //Search
            searchJobsites(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/jobsites/search', {term: searchTerm})
                    .then(response => {
                        //Set the data
                        this.jobsiteOptions = response.data;

                        //Done loading
                        searchLoading(false);
                    });
            },

            addJobsiteToFolder(jobsite){
                //Make sure the folder has not already been added
                for (var i = this.jobsites.length - 1; i >= 0; i--)
                {
                    //Check it
                    if(this.jobsites[i].JobsiteId == jobsite.JobsiteId)
                    {
                        //Alert the uers
                        this.$toastr.warning('Folder: '+jobsite.jobsite_name_nbr+' is already linked to this Folder');

                        //Stop
                        return;
                    }
                }

                //Fire it
                this.$http.post('/drive/folders/asset/Jobsite/'+jobsite.JobsiteId+'/'+this.active_folder.id)
                    .then(res => {
                        //Add
                        this.jobsites.push(jobsite);

                        //REset
                        this.new_jobsite = null;
                        this.add_jobsite = false;

                        //Alert
                        //this.$toastr.s('Folder Linked to '+this.assetType);
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //This is alway hit
                        this.loading = false;
                    });
            },

            removeJobsite(jobsite){
                //Confirm
                if(!confirm('Are you sure you want to unlink this jobsite?'))
                {
                    return;
                }

                //Fire it
                this.$http.post('/drive/folders/asset/Jobsite/'+jobsite.JobsiteId+'/'+this.active_folder.id)
                    .then(res => {
                        //Remove it
                        for (var i = this.jobsites.length - 1; i >= 0; i--)
                        {
                            //Check it
                            if(this.jobsites[i].JobsiteId == jobsite.JobsiteId)
                            {
                                this.jobsites.splice(i, 1);
                            }
                        }

                        //Alert
                        this.$toastr.s('Jobsite Unlinked from this folder');
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //This is alway hit
                        this.loading = false;
                    });
            },
        },

        mounted(){
            //Get tit
            this.getActiveFolder(this.starting_folder_id);
        },
    }
</script>

<style type="text/css">
    .vue-dropzone {
        border: 2px dashed #e5e5e5;
    }

    .tree-selected {
        background: #d5fbff !important;
    }

    .breadcrumb-item:hover, #add-file-button:hover {
        cursor: pointer;
    }

    .search-highlight {
        background: #fff700;
    }
</style>